// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","borderContainer":"Button_borderContainer__B4bHe","loader":"Button_loader__S3BdI","l20-1":"Button_l20-1__15QKH","l20-2":"Button_l20-2__BvB1i"};